// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#ffb601","fieldWrapper":"TextInput_fieldWrapper__3DORU"};